<script>
import SyLink from '../../basis/fe-link/index.vue'

export default {
  name: 'sy-button',
  components: {SyLink},
  props: {
    name: {
      type: String,
      default: ''
    },
    // primary（有色实心） / plain（有色线框）/ textPlain（无色线框） / link（行上链接型） / text（纯文本型）
    type: {
      type: String,
      default: 'textPlain'
    },
    // 按钮尺寸 | String | default（默认按钮40px）/ medium（中等按钮36px） / small（小型按钮32px） / mini（小按钮28px）
    size: {
      type: String,
      default: 'small'
    },
    icon: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean
    },
    tooltip: {
      type: String
    },
    to: {
      type: Object
    },
    dataSpmD: {
      type: [String, Number]
    }
  },
  methods: {
    handleClick (evt) {
      if (this.disabled) return
      
      this.dataSpmD && window.fe.spmD(this.dataSpmD)
      
      this.$emit('click', evt)
    },
    linkRender (button) {
      const {to} = this
      return to
        ? (<SyLink
          class="sy-button"
          to={to}
        >
          {button}
        </SyLink>)
        : button
    },
    tooltipRender (button) {
      // 包一层sapn 为了 disable状态下展示tip
      const {tooltip} = this
      return tooltip
        ? (<el-tooltip
          popper-class="sy-button-gallery-button-tooltip-wrap"
          placement="top"
          effect="dark"
          content={tooltip}
        >
          <span>{button}</span>
        </el-tooltip>)
        : button
    },
    buttonRender () {
      const {name, handleClick, disabled, type, size, icon} = this
      const $slots = this.$slots.default || this.$scopedSlots.default
      return (
        <button
          type="button"
          disabled={disabled}
          class={
            [
              'sy-button',
              {
                'is-disabled': disabled,
                'background-color-primary': type === 'primary',
                'border-primary-color font-color-primary': type === 'plain'
              },
              size ? 'sy-button--' + size : '',
              type ? 'sy-button--' + type : ''
            ]
          }
          data-spm-d={this.dataSpmD}
          on-click={handleClick}
        >
          {
            icon && <i class={['sy-button__icon', 'iconfont', icon]}/>
          }
          {
            $slots || name
          }
        </button>
      )
    }
  },
  render (h) {
    return this.tooltipRender(
      this.linkRender(
        this.buttonRender()
      )
    )
  }
}
</script>

<style lang="scss">
.sy-button-gallery-button-tooltip-wrap {
  max-width: 220px;
}
</style>

<style lang="scss" scoped>
.sy-button {
  border: none;
  cursor: pointer;
  border-radius: 4px;
  .sy-button__icon {
    margin-right: 2px;
  }
  &.is-disabled {
    cursor: not-allowed !important;
    opacity: 0.4;
  }

  & + .sy-button {
    margin-left: 8px;
  }
}

// 线框按钮 因为border 需要改padding值
.sy-button-border-style {
  &.sy-button--default {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  &.sy-button--medium {
    padding-top: 7px;
    padding-bottom: 7px;
  }

  &.sy-button--small {
    padding-top: 6px;
    padding-bottom: 6px;
  }

  &.sy-button--mini {
    padding-top: 4px;
    padding-bottom: 4px;
  }
}

// default（默认按钮40px）
.sy-button--default {
  font-size: 14px;
  line-height: 22px;
  padding: 9px 16px;

  .iconfont {
    font-size: 14px;
  }
}

// medium（中等按钮36px）
.sy-button--medium {
  font-size: 12px;
  line-height: 20px;
  padding: 8px 16px;

  .iconfont {
    font-size: 12px;
  }
}

// small（小型按钮32px）
.sy-button--small {
  font-size: 12px;
  line-height: 18px;
  padding: 7px 16px;

  .iconfont {
    font-size: 12px;
  }
}

// mini（小按钮28px）
.sy-button--mini {
  font-size: 12px;
  line-height: 18px;
  padding: 5px 16px;

  .iconfont {
    font-size: 12px;
  }
}

// primary（有色实心）
.sy-button--primary {
  color: #fff;

  &:hover {
    opacity: 0.7;
  }

  &.is-disabled {
    &:hover {
      opacity: 0.4;
    }
  }
}

// plain（有色线框）
.sy-button--plain {
  background-color: #fff;
  border: 1px solid;
  @extend .sy-button-border-style;

  &:hover {
    opacity: 0.7;
  }

  &.is-disabled {
    &:hover {
      opacity: 0.4;
    }
  }
}

// textPlain（无色线框）
.sy-button--textPlain {
  border: 1px solid #D2D5E1;
  color: #242F57;
  background-color: #fff;
  @extend .sy-button-border-style;

  &:hover {
    opacity: 0.7;
  }

  &.is-disabled {
    background-color: #fff;

    &:hover {
      opacity: 0.4;
    }
  }
}

// link（行上链接型）
.sy-button--link {
  line-height: 20px;
  background-color: transparent;
  padding: 0;
  color: #3072F3;

  &:hover {
    opacity: 0.7;
  }

  &.is-disabled {
    opacity: 0.4;

    &:hover {
      opacity: 0.4;
    }
  }
}

// text（纯文本型）
.sy-button--text {
  line-height: 20px;
  background-color: transparent;
  padding: 4px 8px;
  color: #242F57;

  &:hover {
    background: #F4F7FC;
    border-radius: 4px;
  }

  &.is-disabled {
    opacity: 0.4;

    &:hover {
      background: transparent;
      border-radius: 0;
    }
  }
}
</style>
